import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { RoutesMap } from './routes-map';

export default function Routes() {
  return (
    <RouterProvider router={createBrowserRouter(RoutesMap)} />
  )
}
